
import { defineComponent } from 'vue'

/**
 * 分割スクロール
 */
export default defineComponent({
  name: 'DoubleScroll',
  props: {
    leftSpan: {
      type: Number,
      required: false,
      default: 12,
    },
    rightSpan: {
      type: Number,
      required: false,
      default: 12,
    },
  },
})
